import { ActiveFee } from '../../../interfaces/cart'
import { IProduct } from '../../../interfaces/catalog'
import { getQtyPerPackageType } from '../../../utils'

/**
 * get total quantity of items in group
 */
export const getTotalItems = (items: IProduct[]) =>
  items?.reduce(
    (count: number, item: IProduct) =>
      count + getQtyPerPackageType(item.quantity, item.packageType),
    0
  )

export const getTotalDiscounts = (
  discountValue: number | undefined,
  quantity: number
): number | undefined => {
  const hasDiscount = typeof discountValue === 'number'
  const discount = hasDiscount ? discountValue * quantity : undefined
  return discount
}

/**
 * Unify active fees by type
 * @param activeFees: ActiveFee[]
 * @returns ActiveFee[]
 */
export const unifyActiveFees = (activeFees: ActiveFee[] = []) => {
  const unifiedActiveFees = activeFees?.reduce((acc: ActiveFee[], curr) => {
    const feeIndex = acc.findIndex(({ fee }) => fee.type === curr.fee.type)
    if (feeIndex > -1) {
      acc[feeIndex].total += curr.total
    } else {
      acc.push(curr)
    }
    return acc
  }, [])
  return unifiedActiveFees
}
